import Create from "./Create";
import Edit from "./Edit";
import List from "./List";
import { RoleIcon } from "../icons";

export default {
  options: {
    group: "admin",
    accessible: ({ user }) =>
      user.role === "admin" && user.permissions.indexOf("role/list") !== -1,
  },
  icon: RoleIcon,
  list: List,
  edit: Edit,
  create: Create,
};
